/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('nodeInviteModal', ['nodeModalAction', '$translate', function (nodeModalAction, $translate) {
        return function ($scope, attrs) {
            $translate('Invite to %{node_name}', {node_name: $scope.node['name']}).then(function (title) {
                nodeModalAction($scope, angular.extend({
                    modalController: "FolderShareController",
                    modalType: "confirm",
                    modalAction: "invite",
                    modalBodyTemplate: "nodes/folder_share",
                    modalTitle: title,
                    modalNotifications: true
                }, attrs));
            })
        }
    }]);
